module.exports = __webpack_public_path__ + "static/img/3.672d3c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/eng/3.png
// module id = dD8v
// module chunks = 0